// extracted by mini-css-extract-plugin
var _1 = "DownloaderElement_icon__4e907";
var _2 = "DownloaderElement_iconType__6670c";
var _3 = "DownloaderElement_size__8f17a";
var _4 = "DownloaderElement_text__59e3c";
export { _1 as "icon", _2 as "iconType", _3 as "size", _4 as "text" }
